// extracted by mini-css-extract-plugin
export var always = "styles-module--always--f9da0";
export var arrow = "styles-module--arrow--feb5c";
export var blue = "styles-module--blue--42f57";
export var collapse = "styles-module--collapse--b92b9";
export var content = "styles-module--content--855f9";
export var green = "styles-module--green--0a505";
export var header = "styles-module--header--92499";
export var hide = "styles-module--hide--35c0d";
export var separator = "styles-module--separator--ba09a";
export var summary = "styles-module--summary--8a834";
export var title = "styles-module--title--af668";
export var white = "styles-module--white--6754a";
export var wrapper = "styles-module--wrapper--1917e";